import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation5 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (




        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                       Certificate Course in IT Desktop & Hardware Support

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 240 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%"}}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in IT Desktop & Hardware Support
                </h5>
                <p>
                    Desktop Support Technician is the one who:  </p>
                <ul>
                    <li>Configures, maintains the operating systems on desktops and laptops</li>
                    <li>He/She can also migrate or upgrade the existing operating systems on desktops</li>
                    <li>Installation and configuration of operating systems on bulk PCs using system imaging tools</li>
                </ul>
                <p>As a hardware support technician, it is essential to have a good understanding of operating systems (OS) and how they interact with hardware. In addition to knowledge of different operating systems, it is also important to have a good understanding of requirements for Operating System installations, actual installation steps of an Operating System, Windows Operating system features, Hard disk partitioning etc. Also, it is always beneficial to have some basic knowledge of networking concepts.</p>

            </div>
            <hr />
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>
            <p>A desktop support technician can work with companies/enterprises having an IT infrastructure including desktops and laptops or the companies who are providing operating system sales and support.</p>
            <p>The career opportunities for Desktop Support Technician are:</p>
            <ul><li>Companies/enterprises having an IT infrastructure</li>
                <li>Companies who are providing operating system sales and support</li></ul>
            <p>A hardware support technician can work with companies/enterprises having an IT infrastructure including desktops and laptops or the companies who are providing hardware sales and support.</p>
            <p>He/She can do a job or can work as an IT Hardware Support Consultant. A fresher can draw up to Rs. 100,000/- p.a.</p>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> IT Desktop & Hardware Support course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>
            <h5>1. IT Desktop Support</h5>
            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Operating Systems</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Overview of Operating system</li>
                                <li>Types of Operating Systems</li>
                                <li>Overview of Windows 8 Operating system</li>
                                <li> Overview of Windows 10 Operating system</li>
                                <li>Installing Windows 7 Operating system</li>
                                <li>Installing Ubuntu on a PC</li>
                                <li>Installing Windows server 2008 R2</li>
                                <li>Creating Windows 10 Bootable Pen drive</li>
                                <li>Installing Windows 10 Operating system</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Creating Virtual Operating System Environment </AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li> Virtualization</li>
                                <li>Creating Virtual Operating System Environment</li>
                                <li> Creating Windows 7 Virtual Operating System</li>
                                <li>Creating Ubuntu Virtual Operating System</li>
                                <li>Configuring Virtual Operating System Environment</li>
                                <li>Configuring Windows 7 Virtual Machine</li>
                                <li>Using electa Screen Recorder and Format Factory</li>
                                <li>Configuring Ubuntu Virtual Machine</li>
                                <li>Creating ISO File from a Data CD or DVD</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Managing Users and Groups</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>Users in Linux</li>
                                <li>Users in Windows</li>
                                <li>Creating Users and Groups in Linux</li>
                                <li>Creating Users and groups in Windows</li>
                                <li>Managing Users and Groups in OS</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">File System in OS</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li> File System in Linux</li>
                                <li> File System in Windows</li>
                                <li> Assigning File Permissions in Linux</li>
                                <li>Combining Shared Folder and NTFS Permissions in Windows</li>
                                <li>Files and Folders Permissions in Windows</li>
                                <li> File System in OS</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Disks and Devices Management</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li> Partitioning a Hard Disk</li>
                                <li>Managing Devices and Drivers in an OS</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Configuring backups and System images </AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Configuring backups in Windows Operating System</li>
                                <li>Capturing Disk Image -Backup</li>
                                <li>Capturing Disk Image -Restore</li>
                                <li>Configuring Backups in Windows Operating System</li>
                                <li>Configuring Backups</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Post Installation configurations and maintenance of an OS</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li> Configuring Regional Language Settings</li>
                                <li> Configuring Remote Desktop Settings</li>
                                <li> Enabling Regional language settings</li>
                                <li> Installing Google Input Tool for Hindi Typing</li>
                                <li> Enabling Remote Desktop Settings</li>
                                <li> Configuring Disk Analyzing tool</li>
                                <li> Configuring Performance Tuning Tool for a PC</li>
                                <li> Hardware Monitoring Tools for Operating Systems</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Managing and Maintaining Windows 7 Desktop OS</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li> Migrating to Windows7</li>
                                <li>Performance settings in Windows7</li>
                                <li> Problem steps recorder</li>
                                <li>Remote Assistance</li>
                                <li> Securing Browser in Windows7</li>
                                <li> Updating Windows7</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <hr></hr>
                <p><b>Skills:</b> Installing Windows 7 OS, Installing Ubuntu on a PC, Installing Windows server 2008 R2, Creating Virtual OS Environment, Creating Windows 7 Virtual Operating System, Managing Devices and Drivers in an OS, Configuring backups in Windows 7, Capturing Disk Image - Backup, Capturing Disk Image -Restore, Configuring Regional Language Settings</p>
                <p><b>Outputs:</b> Operating system installation utilities, Virtual Operating systems, Hard disk analyzing tools, Remote desktop softwares, Disk partitioning tools, Windows users and file management, Regional language typing tools </p>
                <hr></hr>
                <h5>2. IT Hardware Support</h5>
                <hr></hr>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Introduction to Operating Systems</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>Introduction to Operating Systems</li>
                                <li>Types of Operating Systems</li>
                                <li>Overview of Microsoft Operating System</li>
                                <li>Introduction to Linux operating system</li>
                                <li>Client vs Server Operating System</li>
                                <li>Installing software for Writing CD and creating ISO images</li>
                                <li>Windows 10 Operating System</li>
                                <li>Windows 10 installation</li>
                                <li>Types of Partitions</li>
                                <li>Basics of Computer Networking</li>
                                <li>Different types of Internet Connectivity</li>
                                <li>Difference between Static and Dynamic IP Address</li>
                                <li>Configuring Wi-Fi network</li>
                            </ul>


                        </AccordionBody >
                    </AccordionItem >
                </Accordion >
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Introduction to IT Hardware</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Identifying System Unit Components</li>
                                <li>Input Hardware Devices</li>
                                <li>Output Hardware Devices</li>
                                <li>Basic Hardware Connections</li>
                                <li>Modern Types of Connectors – USB, OTG, NFC</li>
                                <li>External Hardware and Peripherals Connections</li>
                                <li>Motherboard Overview</li>
                                <li>Motherboard Components</li>
                                <li>Understanding CPU characteristics</li>
                                <li>CPU Cooling Techniques</li>
                                <li>Multimedia Devices</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Overview of Storage Devices</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li>Identifying Storage Devices</li>
                                <li>SATA Drives</li>
                                <li>SSDs</li>
                                <li>SCSI Drives</li>
                                <li>Overview RAID storage</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="18">Understanding printers</AccordionHeader>
                        <AccordionBody accordionId="18">
                            <ul>
                                <li>Understanding laser printers</li>
                                <li> Understanding Inkjet Printers</li>
                                <li> Understanding Thermal Printers</li>
                                <li>Understanding Impact Printers</li>
                                <li>Setting up and Installing a Printer</li>
                                <li>Wireless printing</li>
                                <li>Printer toner refilling</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="19">Modern Hardware devices and gadgets</AccordionHeader>
                        <AccordionBody accordionId="19">
                            <ul>
                                <li>Installing Various Types of Hardware Components</li>
                                <li>Readers and scanners</li>
                                <li>Projector</li>
                                <li>CCTV and Surveillance system</li>
                                <li>Computer Firmwares</li>
                                <li>Assembling a PC</li>
                                <li>UPS and Inverters</li>
                                <li>Basic Electronics overview</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="20">Overview of Laptop Hardware</AccordionHeader>
                        <AccordionBody accordionId="20">
                            <ul>
                                <li> Laptop Inbuilt Hardware components - Speakers, Motherboards & CPU</li>
                                <li>Laptop Internal Hardware-Memory & Optical Drives Laptop RAM and SSDs</li>
                                <li>Laptop Components- Express Cards and Expansion Cards</li>
                                <li>Servicing laptop hardware - Tablets vs Laptops</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="21">TroubleShooting IT Hardware</AccordionHeader>
                        <AccordionBody accordionId="21">
                            <ul>
                                <li>Troubleshooting hardware devices</li>
                                <li>Troubleshooting laptop components</li>
                                <li>Troubleshooting Hard Drives</li>
                                <li>Troubleshooting Printers</li>
                                <li>Desktop chip level repairing basics</li>
                                <li>Mobile repairing – Basics of mobile repairing</li>
                                <li>Laptop chip level repairing basics</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="22">Computer Safety and Operational Procedures</AccordionHeader>
                        <AccordionBody accordionId="22">
                            <ul>
                                <li> Computer Safety Procedures</li>
                                <li> Managing Computing Environments</li>
                                <li> Managing Safety Hazards</li>
                                <li>PC Hardware-Electrostatic Discharge Tools</li>
                                <li>Computer and Laptop Cleaning Tools</li>
                                <li>PC Hardware Diagnostic Tools</li>
                                <li>Securing Computers</li>
                                <li>Computer Hardware Recycling</li>
                                <li> Communication and Professionalism</li>


                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
            </div >
            <hr />

            <p><b>Skills:</b>Identifying PC Components, Identifying System Unit Components, Identifying Storage Devices, Assembling a PC, Installing and Configuring a Printer, Troubleshooting and Maintaining Printers, Troubleshooting PC Hardware, Managing safety Hazards, Communication and Professionalism</p>
            <p><b>Outputs:</b>PC Hardware, Hardware Monitoring Tools, Multi meters</p>

            <br />
            <hr />


            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    

    );
}
export default CertificateInformation5;